const prod = {
  url: "ale34.pl-prod",
};

const dev = {
  url: "ale34.pl-dev",
};

export const config = process.env.NODE_ENV === "development" ? dev : prod;
